import {Component, Input} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {NgForOf} from '@angular/common';
import {SafePipe} from '../pipes/safe.pipe';

@Component({
  selector: 'app-powerbi-content',
  templateUrl: './powerbi-content.component.html',
  imports: [
    NgForOf,
    SafePipe
  ],
  styleUrls: ['./powerbi-content.component.scss']
})
export class PowerbiContentComponent {

  @Input() data: any = undefined;

  constructor(private sanitizer: DomSanitizer) {
  }

}
